import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackGateEvent } from "../../lib/gateAnalytics";
import { GATE_BACKGROUND, ResearchConfirmationPanel } from "./ResearchConfirmationPanel";

export function ResearchGateOverlay({ onAccept }) {
  const { pathname } = useLocation();
  const ref = useRef(null);

  useEffect(() => {
    trackGateEvent("gate_view", { page_path: pathname, gate_display: "overlay" });
    ref.current?.focus();
    const root = document.documentElement;
    const prevOverflow = root.style.overflow;
    root.style.overflow = "hidden";
    // Header/footer sit outside the gated content wrapper — make them inert too.
    const chrome = [...document.querySelectorAll("header[data-testid^=site-header], footer[data-testid^=site-footer]")]
      .filter((el) => !el.hasAttribute("inert"));
    chrome.forEach((el) => el.setAttribute("inert", ""));
    return () => {
      root.style.overflow = prevOverflow;
      chrome.forEach((el) => el.removeAttribute("inert"));
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const trapFocus = (e) => {
    if (e.key !== "Tab") return;
    const items = ref.current.querySelectorAll("a[href], button:not([disabled])");
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;
    if (e.shiftKey && (active === first || active === ref.current)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  };

  return (
    <div
      ref={ref}
      tabIndex={-1}
      role="dialog"
      aria-modal="true"
      aria-labelledby="research-gate-title"
      data-testid="research-gate-overlay"
      onKeyDown={trapFocus}
      className="fixed inset-0 z-[45] overflow-y-auto flex flex-col justify-between px-6 pb-8 pt-16 sm:pt-24 text-white outline-none"
      style={{ backgroundImage: GATE_BACKGROUND }}
    >
      <ResearchConfirmationPanel
        headingAs="h2"
        headingId="research-gate-title"
        onYes={onAccept}
        onNo={() => trackGateEvent("eligibility_no", { gate_display: "overlay" })}
      />
    </div>
  );
}
